module.exports = __webpack_public_path__ + "static/img/little_assistant.b643688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/little_assistant.png
// module id = dNyD
// module chunks = 1